export const Emit_Event = {
    MATCH_SENSOR: "match-sensor", // 匹配传感器
    MATCH_SENSOR_FINISH: "match-sensor-finish", // 匹配传感器完成
    UPDATE_MONITOR_PARAMETER: "update-monitor-parameter", // 参数设计，更新了监测参数的详情
    UPDATE_MONITOR_OBJECT: "update-monitor-object", // 更新了监测对象的详情
    ADD_MONITOR_OBJECT_FINISH: "add-monitor-object-finish", // 添加了监测对象，更新侧边栏
    WARNING_PANEL: "warning-panel", // 大屏点击报警按钮侧边栏弹出
    LINE_CHART_UPDATE: "line-chart-update", // linechart射线图更新信号
    START_COLLECTION: "start-collection", // 建模端点击采集信号
    STOP_COLLECTION: "stop-collection", // 建模端点击暂停信号
    TOGGLE_COMPASS: "toggle_compass", // 大屏切换指北针显示隐藏
}